<template>
  <div class="post-comment">
    <div class="comment-wrap">
      <img class="post-comment__user-icon" :src="comment.author_logo">
      <div class="post-comment__body">
        <div class="post-comment__user-name">
          {{ comment.author }}
        </div>
        <div class="post-comment__text" v-html="comment.text"></div>
        <div class="post-comment__images" v-if="comment.images && comment.images.length">
          <img class="post-comment__image" v-for="image in comment.images" :src="image" width="200px">
        </div>
      </div>

    </div>
    <div class="post-comment__date ">
      {{ moment(comment.created_date).format('HH:mm DD.MM.YYYY') }}
    </div>
    <post-re-comment v-if="parseInt(comment.children)" :comment="comment"/>
  </div>
</template>

<script>
import PostReComment from './postReComment.vue';
import moment from 'moment/moment';

export default {
  name: 'postComment',
  components: { PostReComment },
  props: {
    comment: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {
      showReComment: false,
      moment,
    };
  },
};
</script>

<style lang="stylus">
.post-comment
  display flex
  flex-direction column
  width 100%
  margin-top 1em
  box-sizing border-box
  &__user-icon
    width 2.5em
    height 2.5em
    border-radius 50%
    margin .5em 1em 0 0
    flex-shrink 0
  &__body
    padding-bottom 1em
    box-sizing border-box
  &__user-name
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: normal;

    color: #000000;
    margin .3em 0
  &__date
    font-style: normal;
    font-weight: 500;
    font-size: 9px;
    line-height: normal;

    color: #55626F;
    margin .3em 0 .7em 0
.post-re-comment-prev
  width 100%
  display flex
  align-items center
  margin-left 3.6em
  &:hover
    text-decoration underline
    cursor pointer
  &__user-icon
    width 2.2em
    height 2.2em
    border-radius 50%
    margin 1em 1em 1em 0
    flex-shrink 0
  &__user-name
    color #460303
  &__count
    font-weight bold
    color #460303
.comment-wrap {
  display flex
  flex-direction row
  padding-bottom 14px
}
.post-comment__images {
  position relative
  display flex
  flex-wrap wrap
  align-items center
}

.post-comment__image {
  width 250px
  margin-right 5px
  margin-bottom 5px
}

.post-comment__image:last-child {
  margin 0
}

.post-comment__date {
  border-top: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  padding 4px 0;
  color #55626F;
  text-align right;
}
</style>
